
import app from '../../App';

export default class PayByCheckService {
    constructor ( $log, $http, Info) {

        'ngInject';
        this._$http=$http;
        this.Info=Info;
    }

    getFields(){
        return  this._$http({
            method: 'GET',
            url: `https://api.hubapi.com/forms/v2/fields/62499a72-00a8-49a6-846f-3f98eee0bf4d?hapikey=${this.Info.hubspotApiKey}`
        });
    }

    sendPayByCheckForm(name='',email='',phone='',companyName='',plan='monthly',displays=0,devices=0){
        return  this._$http({
            method: 'POST',
            url: `https://forms.hubspot.com/uploads/form/v2/${this.Info.hubspotPortalId}/62499a72-00a8-49a6-846f-3f98eee0bf4d`,
            data: {
                firstname: name,
                lastname: '',
                email: email,
                phone: phone,
                message: '',
                calculator_plan_name:'',
                calculator_annual_or_monthly_selected:'',
                calculator_licenses:'',
                calculator_devices:'',
                calculator_checkout_link:'',
                calculator_price_of_next_license:'',
                calculator_pdf_quote_link:''
            },
            transformRequest: function(obj) {
                var str = [];
                for(var p in obj)
                    if(encodeURIComponent(obj[p])!='')
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                console.log(str.join("&"));
                return str.join("&");
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
    }
};

app.service( 'PayByCheckService', PayByCheckService );


// WEBPACK FOOTER //
// ./src/js/services/checkout-flow/PayByCheckService.js